(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7646],{

/***/ 56306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customers/[slug]",
      function () {
        return __webpack_require__(92841);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 92841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@graphcms/rich-text-react-renderer/dist/rich-text-react-renderer.esm.js + 1 modules
var rich_text_react_renderer_esm = __webpack_require__(60392);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(89755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./components/Customers/CustomerQuote/CustomerQuote.module.scss
var CustomerQuote_module = __webpack_require__(57745);
var CustomerQuote_module_default = /*#__PURE__*/__webpack_require__.n(CustomerQuote_module);
// EXTERNAL MODULE: ./components/common/Typography/Typography.tsx
var Typography = __webpack_require__(20026);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./components/Customers/CustomerQuote/CustomerQuote.tsx





const CustomerQuote = (param)=>/*#__PURE__*/ {
    let { content , author , authorAvatar , role  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (CustomerQuote_module_default()).customerQuote,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("blockquote", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((CustomerQuote_module_default()).quote, (CustomerQuote_module_default()).leftQuote),
                        children: "“"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy2",
                        emphasis: true,
                        children: content
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: classnames_default()((CustomerQuote_module_default()).quote, (CustomerQuote_module_default()).rightQuote),
                        children: "”"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (CustomerQuote_module_default()).quoteAuthor,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: (CustomerQuote_module_default()).avatar,
                        src: authorAvatar,
                        alt: "Author picture",
                        objectFit: "cover",
                        width: 48,
                        height: 48
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* Typography */.Z, {
                        type: "copy3",
                        emphasis: true,
                        children: [
                            author,
                            ","
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                        type: "copy3",
                        children: role
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Customers/Customers.module.scss
var Customers_module = __webpack_require__(53516);
var Customers_module_default = /*#__PURE__*/__webpack_require__.n(Customers_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/common/CallToAction/FooterCallToAction.tsx + 1 modules
var FooterCallToAction = __webpack_require__(24035);
// EXTERNAL MODULE: ./components/common/Footer/Footer.tsx + 1 modules
var Footer = __webpack_require__(5945);
// EXTERNAL MODULE: ./components/common/Navbar/Navbar.tsx + 4 modules
var Navbar = __webpack_require__(93890);
// EXTERNAL MODULE: ./public/images/ReturnIcon.tsx
var ReturnIcon = __webpack_require__(69976);
;// CONCATENATED MODULE: ./pages/customers/[slug].tsx











const CustomerPage = (param)=>{
    let { customer , previousCase , nextCase  } = param;
    var ref, ref1, ref2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Customers_module_default()).detailsLayout,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Customers_module_default()).caseBackLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/customers",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ReturnIcon/* default */.Z, {}),
                                    "All customers"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Customers_module_default()).caseContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Customers_module_default()).caseTitle,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (Customers_module_default()).caseOverline,
                                        children: "Customer Case Study"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(rich_text_react_renderer_esm/* RichText */.H, {
                                    content: customer.caseStudy.raw,
                                    references: customer.caseStudy.references,
                                    renderers: {
                                        embed: {
                                            Quote (props) {
                                                const { id , body , author  } = props;
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerQuote, {
                                                    content: body,
                                                    author: "".concat(author.firstName, " ").concat(author.lastName),
                                                    role: author.title,
                                                    authorAvatar: author.profilePhoto.url
                                                }, id);
                                            }
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Customers_module_default()).casePageLinks,
                                    children: [
                                        previousCase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                                            label: "Previous Customer",
                                            slug: previousCase.slug,
                                            logo: (ref = previousCase.companyLogo) === null || ref === void 0 ? void 0 : ref.url
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                                        nextCase && /*#__PURE__*/ (0,jsx_runtime.jsx)(PageLink, {
                                            label: "Next Customer",
                                            slug: nextCase.slug,
                                            logo: (ref1 = nextCase.companyLogo) === null || ref1 === void 0 ? void 0 : ref1.url
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Customers_module_default()).caseCustomerDetails,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Customers_module_default()).caseDetailsLogo,
                                    children: ((ref2 = customer.companyLogo) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: customer.companyLogo.url,
                                        layout: "fill",
                                        objectFit: "contain",
                                        objectPosition: "left",
                                        alt: "Company Logo"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (Customers_module_default()).caseDetailsBody,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetailsSection, {
                                            label: "About the company",
                                            body: customer.about
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetailsSection, {
                                            label: "Founded",
                                            body: new Date(customer.founded).getFullYear().toString()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerDetailsSection, {
                                            label: "Using Highlight since",
                                            body: new Date(customer.usingHighlightSince).toLocaleDateString(undefined, {
                                                month: "short",
                                                year: "numeric"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterCallToAction/* FooterCallToAction */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
const PageLink = (param)=>/*#__PURE__*/ {
    let { label , slug , logo  } = param;
    return (0,jsx_runtime.jsx)((link_default()), {
        href: "/customers/".concat(slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Customers_module_default()).casePageLink,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                    type: "copy2",
                    emphasis: true,
                    children: label
                }),
                logo && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: logo,
                    width: 187,
                    height: 32,
                    objectFit: "contain",
                    objectPosition: "left",
                    alt: "".concat(slug, " logo")
                })
            ]
        })
    });
};
const CustomerDetailsSection = (param)=>/*#__PURE__*/ {
    let { label , body  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (Customers_module_default()).caseDetailsBlock,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                emphasis: true,
                children: label
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.Z, {
                type: "copy3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (Customers_module_default()).caseDetailsSecitonText,
                    children: body
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = (CustomerPage);


/***/ }),

/***/ 69976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

const ReturnIcon = ()=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M19 7V11H5.83L9.41 7.41L8 6L2 12L8 18L9.41 16.59L5.83 13H21V7H19Z",
            fill: "currentColor"
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (ReturnIcon);


/***/ }),

/***/ 57745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerQuote":"CustomerQuote_customerQuote__abJ8P","quoteAuthor":"CustomerQuote_quoteAuthor__SZUl_","quote":"CustomerQuote_quote__sjbg9","leftQuote":"CustomerQuote_leftQuote__GR8lm","rightQuote":"CustomerQuote_rightQuote__gI_ZE","avatar":"CustomerQuote_avatar__RiG5h"};

/***/ }),

/***/ 53516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customerCard":"Customers_customerCard__gfhl0","companyDiv":"Customers_companyDiv__sYdH0","companyLogo":"Customers_companyLogo__Ht_4p","avatar":"Customers_avatar__LftWw","authorDiv":"Customers_authorDiv__EbgY8","reviewGrid":"Customers_reviewGrid__gZi0O","detailsLayout":"Customers_detailsLayout__7Pj8X","caseTitle":"Customers_caseTitle__TMjI2","caseBackLink":"Customers_caseBackLink__BOD0t","casePageLinks":"Customers_casePageLinks__bz_Lo","casePageLink":"Customers_casePageLink__Igtww","caseContent":"Customers_caseContent__3Y6nc","caseCustomerDetails":"Customers_caseCustomerDetails___ei3N","caseOverline":"Customers_caseOverline__CwI1t","caseDetailsLogo":"Customers_caseDetailsLogo__uDw_P","caseDetailsBody":"Customers_caseDetailsBody__Ucmby","caseDetailsBlock":"Customers_caseDetailsBlock__vtI6s","caseDetailsSecitonText":"Customers_caseDetailsSecitonText__SR2s8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,4617,6556,3826,1399,392,4117,3890,9774,2888,179], function() { return __webpack_exec__(56306); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);